import type { ModalRegistryEntry } from '../../types/modal.types';

// Import modal components
import {
  ReportModal,
  ReviewModal,
  RegistrationModal,
  ConfirmEmailModal,
  TaskCreatedModal,
  SettingsModal,
  LoginModal,
  PostTaskModal,
  SubmitProposalModal,
  DeleteOrderModal,
  CompleteOrderModal,
  CreateReviewModal,
  ReviewDetailsModal,
  LocationPickerModal,
  ChangePasswordModal,
  OrderLocationModal,
} from '@features/modals';

/**
 * Modal Registry
 * All modal components must be registered here to be accessible
 * via the modal management system
 */
export const modalRegistry: ModalRegistryEntry<any>[] = [
  {
    id: 'report',
    component: ReportModal,
    config: { size: 'md', animation: 'slide-up' },
  },
  {
    id: 'review',
    component: ReviewModal,
    config: { size: 'md', animation: 'slide-up' },
  },
  {
    id: 'registration',
    component: RegistrationModal,
    config: { size: 'lg', animation: 'slide-up' },
  },
  {
    id: 'confirm-email',
    component: ConfirmEmailModal,
    config: { size: 'md', animation: 'fade', position: 'center' },
  },
  {
    id: 'task-created',
    component: TaskCreatedModal,
    config: { size: 'md', animation: 'zoom', position: 'center' },
  },
  {
    id: 'settings',
    component: SettingsModal,
    config: { size: 'xl', animation: 'slide-up' },
  },
  {
    id: 'login',
    component: LoginModal,
    config: { size: 'lg', animation: 'fade' },
  },
  {
    id: 'post-task',
    component: PostTaskModal,
    config: { size: 'lg', animation: 'slide-up' },
  },
  {
    id: 'submit-proposal',
    component: SubmitProposalModal,
    config: { size: 'md', animation: 'slide-up' },
  },
  {
    id: 'delete-order',
    component: DeleteOrderModal,
    config: { size: 'sm', animation: 'zoom' },
  },
  {
    id: 'complete-order',
    component: CompleteOrderModal,
    config: { size: 'sm', animation: 'zoom' },
  },
  {
    id: 'create-review',
    component: CreateReviewModal,
    config: { size: 'md', animation: 'zoom' },
  },
  {
    id: 'review-details',
    component: ReviewDetailsModal,
    config: { size: 'md', animation: 'zoom' },
  },
  {
    id: 'location-picker',
    component: LocationPickerModal,
    config: { size: 'lg', animation: 'slide-up' },
  },
  {
    id: 'order-location',
    component: OrderLocationModal,
    config: { size: 'lg', animation: 'slide-up' },
  },
  {
    id: 'change-password',
    component: ChangePasswordModal,
    config: { size: 'md', animation: 'fade' },
  },
  // TODO: Add remaining modals:
  // - portfolio
  // - select-time
  // - add-photo
  // - profile-contractor
  // - profile-client
];
